module.exports = new __parcel__URL__("project-empty.0864e274.svg").toString();